import React, { useState, useEffect } from 'react';
import { useStateValue } from './StateProvider';
import axios from 'axios';
import moment from 'moment';

import configData from './Config';

function User({ state, setState }) {
    const [{ projects }, dispatch] = useStateValue();
    const [userid, setUserid] = useState([]);
    const [subscriptionsstatus, setSubscriptionsstatus] = useState([]);

    const [editusername, setEditusername] = useState(false);
    const [newusername, setNewusername] = useState('');

    const [editpassword, setEditpassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [result, setResult] = useState('');

    useEffect(() => {
        setNewusername(state.user.username);
    }, [state.user]);

    useEffect(() => {
        const uniqueIds = projects.map(project => project.userid)
            .filter((userId, index, array) => array.indexOf(userId) === index);
        setUserid(uniqueIds)

        const data = {
            subscribers: uniqueIds
        }
        console.log(data)
        axios.post(configData.CONTROLLERURL + configData.GETSUBSCRIBERSTATUS, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Users status data received')
            console.log(res.data)
            if (res.data instanceof Array) {
                setSubscriptionsstatus(res.data);
            }
            else {
                console.log('error')
            }
        })
    }, []);

    const handleChangePassword = () => {
        console.log('Trying to change password');
        setResult(null)

        if (newPassword !== confirmPassword) {
            setResult('Passwords dont\'t match');
            return;
        }

        const data = {
            userid: state.user.userid,
            usertoken: state.user.usertoken,
            newpassword: newPassword
        }

        axios.post(configData.CONTROLLERURL + configData.CHANGEPASSWORD, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Change password data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setResult(res.data.data)
                }
                else {
                    setResult(res.data.data)
                }
            }
            else {
                setResult('Error')
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        })
    };

    const handleChangeUsername = () => {
        console.log('Trying to change username');
        setResult(null)

        const data = {
            userid: state.user.userid,
            newusername: newusername,
        }

        axios.post(configData.CONTROLLERURL + configData.SAVEPROFILE, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Change username data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    dispatch({
                        type: 'ADD_USERNAME',
                        username: newusername
                    });
                    setResult(res.data.data)
                }
                else {
                    setResult(res.data)
                }
            }
            else {
                setResult('Error')
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        })
    };

    return (
        <div className='modal_body'>
            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='modal_label'>User email</div>
                </div>
                <div className='modal_rowsection'>
                    <div className='modal_label'>{state.user.useremail}</div>
                </div>
                <div className='modal_rowsection'>
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='modal_label'>User name</div>
                </div>
                <div className='modal_rowsection'>
                    <div className='modal_label'>{state.user.username}</div>
                </div>
                <div className='modal_rowsection'>
                    <button className='button' onClick={() => setEditusername(true)}>Change Username</button>
                </div>
            </div>

            {
                editusername &&
                <div className='modal_row'>
                    <div className='modal_rowsection'>
                    </div>
                    <div className='modal_rowsection'>
                        <div className='profile_password-inputs'>
                            <input
                                type='text'
                                placeholder='New Username'
                                value={newusername}
                                onChange={(e) => setNewusername(e.target.value)}
                                className='modal_input'
                            />
                        </div>
                    </div>
                    <div className='modal_rowsection'>
                        <button onClick={handleChangeUsername} className='button'>Save Username</button>
                    </div>
                </div>
            }

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='modal_label'>Password</div>
                </div>
                <div className='modal_rowsection'></div>
                <div className='modal_rowsection'>
                    <button className='button' onClick={() => setEditpassword(true)}>Change Password</button>
                </div>
            </div>

            {
                editpassword &&
                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        <input
                            type='password'
                            placeholder='New Password'
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className='input'
                        />
                    </div>
                    <div className='modal_rowsection'>
                        <input
                            type='password'
                            placeholder='Confirm Password'
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className='input'
                        />
                    </div>
                    <div className='modal_rowsection'>
                        <button onClick={handleChangePassword} className='button'>Save Password</button>
                    </div>
                </div>
            }

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <table className='modal_table'>
                        <thead>
                            <tr>
                                <th>Subscriber ID</th>
                                <th>Subscriber Username</th>
                                <th>Subscription</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                userid.map((userid, index) => {
                                    let subscriptionPlan = subscriptionsstatus?.find((sub) => sub.id == userid)

                                    return (
                                        <tr key={'userid' + index}>
                                            <td>{userid}</td>
                                            <td>{subscriptionPlan?.username}</td>
                                            <td>
                                                ID: {subscriptionPlan?.subscriptionid}<br />
                                                Plan: {subscriptionPlan?.subscriptionplan}<br />
                                                From {moment.unix(subscriptionPlan?.subscriptionstart).format('D MMMM YYYY')} to {moment.unix(subscriptionPlan?.subscriptionend).format('D MMMM YYYY')}<br />
                                                Max Users: {subscriptionPlan?.subscriptionmaxusers}<br />
                                                Max Projects: {subscriptionPlan?.subscriptionmaxprojects}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            {result && <div className='result'>{result}</div>}
        </div>
    );
}

export default User;